import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';
import logo from '../../../assets/logo.png';

export default function CTA() {
  const { ref, inView } = useInView(0.12);

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-[#060A12] py-32 sm:py-44 relative overflow-hidden">
      {/* dot grid */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{ backgroundImage: 'radial-gradient(rgba(251,213,67,0.06) 1.5px, transparent 1.5px)', backgroundSize: '28px 28px' }}
      />
      {/* large yellow glow */}
      <div className="pointer-events-none absolute -bottom-20 left-1/4 w-[700px] h-[500px] bg-brand-500/12 rounded-full blur-[140px]" />
      <div className="pointer-events-none absolute top-0 right-0 w-[400px] h-[400px] bg-[#1B3A8A]/20 rounded-full blur-[100px]" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div
          style={{ opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(32px)', transition: 'opacity 0.8s ease, transform 0.8s ease' }}
        >
          {/* logo */}
          <div className="mb-12">
            <img src={logo} alt="LocalContact" className="h-8 w-auto object-contain opacity-60" />
          </div>

          {/* giant statement */}
          <div className="mb-12">
            <h2 className="font-black tracking-[-0.04em] leading-[0.92]">
              <span className="block text-[3.5rem] sm:text-[5.5rem] lg:text-[7.5rem] xl:text-[9rem] text-slate-800">Stop emailing</span>
              <span className="block text-[3.5rem] sm:text-[5.5rem] lg:text-[7.5rem] xl:text-[9rem] text-white">info@.</span>
              <span className="block text-[3.5rem] sm:text-[5.5rem] lg:text-[7.5rem] xl:text-[9rem] text-slate-800">Find who</span>
              <span className="block">
                <span
                  className="inline-block text-[3.5rem] sm:text-[5.5rem] lg:text-[7.5rem] xl:text-[9rem] bg-brand-500 text-slate-900 px-4 sm:px-8 rounded-2xl sm:rounded-3xl leading-[1.05]"
                  style={{ transform: 'rotate(-0.5deg)', display: 'inline-block' }}
                >
                  actually decides.
                </span>
              </span>
            </h2>
          </div>

          <p className="text-[16px] sm:text-[18px] text-slate-500 max-w-lg mb-12 leading-relaxed">
            Name and title for every contact found. One credit per company, not per contact.
          </p>

          <div className="flex flex-wrap items-center gap-5">
            <Link
              to="/register"
              className="inline-flex items-center gap-3 bg-brand-500 text-slate-900 font-black text-[16px] px-10 rounded-2xl hover:bg-brand-400 hover:scale-[1.02] active:scale-[0.98] transition-all duration-150 shadow-2xl shadow-brand-500/30"
              style={{ paddingTop: '1.125rem', paddingBottom: '1.125rem' }}
            >
              Buy credits and start searching
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
            <span className="flex items-center gap-2 text-[13px] text-slate-600 font-medium">
              <svg className="w-3.5 h-3.5 text-brand-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
              No credit card required
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
